module.exports = __webpack_public_path__ + "static/media/permanente.70d96101.png";